import React, { useEffect } from 'react';
import Toggle from "../../../../Forms/Toggle";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import useAxios from "axios-hooks";
import DropDown from "../../../../Forms/DropDown";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import { DatePicker } from "../../../../Forms/DatePicker";
import ComboBox from "../../../../Forms/ComboBox";
import TextField from "../../../../Forms/TextField";
import { Spinner } from "@fluentui/react";

const AudienceStep = ({ courseId, nextOnClick, prevOnClick }) => {
    const [{ loading: loadingCountries, data: countries }] = useAxios('courses/countries');
    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `/courses/${courseId}/audience`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: course, loading }] = useAxios(`courses/${courseId}`);

    
    const statusOptions = [
        { key: "Evergreen", text: "Evergreen" },
        { key: "Expert Review", text: "Expert Review" },
        { key: "Regular Review", text: "Regular Review" },
        { key: "News", text: "News" },
      ];

      const ownerOptions = [
        { key: "Content", text: "Content" },
        { key: "Product", text: "Product"},
        { key: "IT", text: "IT" },
        { key: "Client Success", text: "Client Success"},
        { key: "Marketing", text: "Marketing"} 
      ];

    if (loading || loadingCountries)
        return <Spinner className="absolute-center" label="Loading..." />;

    return (
        <div>
            <Formik
                initialValues={{ 
                    isGlobal: course.isGlobal, 
                    localizedCountries: course.localizedCountries, 
                    excludedCountries: course.excludedCountries,
                    evergreenStatus: course.evergreenStatus, 
                    evergreenReviewDate: course.evergreenReviewDate, 
                    evergreenExpireDate: course.evergreenExpireDate, 
                    evergreenComments: course.evergreenComments,
                    auditOwner: course.auditOwner
                }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
            {({ values, setFieldValue }) => {
                useEffect(() => {
                    if (values.isGlobal) {
                        setFieldValue('localizedCountries', []); // Clear localizedCountries
                    } else {
                        setFieldValue('excludedCountries', []); // Clear excludedCountries
                    }
                }, [values.isGlobal, setFieldValue]);

                return (
                                   <Form style={{width:500}}>
                   
                        <ChoiceGroup
                            label={"Audit Status"}
                            options={statusOptions}
                            name="evergreenStatus"
                            required
                        />
                        {values.evergreenStatus == "Regular Review" &&
                            <DatePicker label="Review Date" name="evergreenReviewDate" allowTextInput required/>
                        }
                        {values.evergreenStatus == "News" &&
                            <DatePicker label="Expiring Date" name="evergreenExpireDate" allowTextInput required/>
                        }

                            <DropDown
                                label="Audit Owner"
                                placeholder="Select Team"
                                name="auditOwner"
                                options={ownerOptions}
                            />
                        <TextField label="Audit Comments" name="evergreenComments" />

                        <Toggle label="Is Global" name="isGlobal" description="" />
                        {values.isGlobal && (
                            <DropDown
                                multiSelect
                                label="HIDE FROM:"
                                name="excludedCountries"
                                options={countries && countries.map(c => ({ key: c.id, text: c.name }))}
                            />
                        )}
                        {!values.isGlobal && (
                            <DropDown
                                multiSelect
                                label="SHOW TO:"
                                name="localizedCountries"
                                calloutProps={{
                                    styles: {
                                      calloutMain: {
                                        maxHeight: 300, // Set max height for dropdown (300px here)
                                        overflowY: 'auto', // Make dropdown scrollable
                                      },
                                    },
                                  }}
                                  styles={{
                                    callout: {
                                      maxHeight: 300, // Set the max height for the dropdown
                                      overflowY: 'auto', // Enable scrolling if content exceeds height
                                    },
                                  }}
                                options={countries && countries.map(c => ({ key: c.id, text: c.name }))}
                            />
                        )}
                        <NavigationalButtons
                            loading={submitting}
                            onNextProps={{ type: "submit", text: "Save and Continue" }}
                            onPrevHandler={prevOnClick}
                        />
                    </Form>
                );
            }}
            </Formik>
        </div>
    );
};


export default AudienceStep;